// extracted by mini-css-extract-plugin
module.exports = {"audits":"admin-portal__DrugAlertAudits__audits","rightRow":"admin-portal__DrugAlertAudits__rightRow"};